export class ScreenLoadingService {
  private _loading = false;

  get loading(){
    return this._loading;
  }

  showLoading(){
    this._loading = true;
  }

  hideLoading(){
    this._loading = false;
  }
}
